export const BOT_LINK = 'https://t.me/podzemelie_saratov_bot'